import { makeStyles, Theme } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "4px 12px",
    borderBottom: `1px solid #eee`,
    "&:nth-child(odd)": {
      backgroundColor: "#f6f6f6"
    }
  },
  leftSideContent: {
    display: "flex"
  },
  donutWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  donut: {
    marginRight: 16,
    width: 28,
    minWidth: 28,
    height: 28
  },
  horseName: {
    textTransform: "uppercase",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  horseExamInfo: {
    fontSize: 12,
    [theme.breakpoints.down(Breakpoints.MD_960)]: {
      maxWidth: 220
    }
  }
}));
